
import { defineComponent, getCurrentInstance, computed } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import { PwaBridge } from '~/common/bridge';
import { compareVersion } from '~/common/utils';

const RightArrow = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/pwa-images/right_icon.png';
const WhatsAppIcon = 'https://cdn-static.ap4r.com/kos/s101/nlav11312/pwa-images/whatapp_icon.png';

export default defineComponent({
    components: {},
    props: {},
    setup(_: unknown) {
        const { proxy } = getCurrentInstance() || {};

        const onClickGoBtn = debounce(async () => {
            try {
                const res = await PwaBridge.openWhatsAppStatusSaver();
                // eslint-disable-next-line no-console
                console.log('res', res);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        }, 300);

        const showStatus = computed(() => {
            if (!proxy?.$isAppEnvironment) {
                return false;
            }

            const appVersion = proxy?.$appConfig?.appver;

            if (!appVersion || compareVersion(appVersion, '1.10.1') < 0) {
                return false;
            }

            return proxy?.$route?.path === '/discover/bomdia';
        });

        return {
            RightArrow,
            WhatsAppIcon,
            showStatus,
            onClickGoBtn,
        };
    },
});
